import { AuthProvider } from '@marvel-common/ridehailing-idp';

export const useSuggestedAuthProvider = (): AuthProvider => {
  return 'cip';
};
